import { UiPricingGridModel } from "../../models";

export function mockUiPricingGridModel({
    id = "pricing-table-1234",
    type = "uiPricingGrid",
    locale = "en",
    content = mockUiPricingGridModelContent()
}: Partial<UiPricingGridModel> = {}): UiPricingGridModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiPricingGridModelContent = UiPricingGridModel["content"];

export function mockUiPricingGridModelContent({
    title = "Lorem ipsum",
    plans = [],
    ...optionals
}: Partial<UiPricingGridModelContent> = {}): UiPricingGridModelContent {
    return {
        title,
        plans,
        ...optionals
    };
}
